import { render, staticRenderFns } from "./FAapproach.vue?vue&type=template&id=1e5fe04f&scoped=true&"
import script from "./FAapproach.vue?vue&type=script&lang=js&"
export * from "./FAapproach.vue?vue&type=script&lang=js&"
import style0 from "./FAapproach.vue?vue&type=style&index=0&id=1e5fe04f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5fe04f",
  null
  
)

export default component.exports